export enum CategoryOthers {
	navigationId = "navigation-id",
	navigationType = "navigation-type",
	page = "page",
	itemId = "item-id",
}
